// Generat automat din README.md
import React from 'react';
import { FileText, Plus, Download } from 'lucide-react';
import Card from '../../components/Card';
import Table from '../../components/Table';
import Badge from '../../components/Badge';
import { mockData, getStatusColor } from '../../utils/mockData';

const EmitereFacturi = () => {
  const columns = [
    { header: 'Numărul facturii', key: 'id' },
    { header: 'Client', key: 'client' },
    { header: 'Sumă', key: 'amount' },
    { 
      header: 'Status', 
      key: 'status',
      render: (value) => <Badge variant={getStatusColor(value)}>{value}</Badge>
    },
    { header: 'Data', key: 'date' }
  ];

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white">Emitere Facturi Electronice</h1>
          <p className="text-gray-600 dark:text-gray-400 mt-2">
            Generare automată de facturi electronice cu integrare ANAF
          </p>
        </div>
        <div className="flex space-x-3">
          <button className="btn-secondary">
            <Download className="w-4 h-4 mr-2" />
            Export
          </button>
          <button className="btn-primary">
            <Plus className="w-4 h-4 mr-2" />
            Factură Nouă
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <Card title="Total Facturi" subtitle="Luna aceasta" icon={FileText}>
          <div className="text-2xl font-bold text-primary-600">124</div>
          <div className="text-sm text-green-600">+12% față de luna trecută</div>
        </Card>
        <Card title="Valoare Totală" subtitle="Luna aceasta" icon={FileText}>
          <div className="text-2xl font-bold text-primary-600">45,250 RON</div>
          <div className="text-sm text-green-600">+8% față de luna trecută</div>
        </Card>
        <Card title="Facturi Plătite" subtitle="Luna aceasta" icon={FileText}>
          <div className="text-2xl font-bold text-primary-600">89%</div>
          <div className="text-sm text-yellow-600">-2% față de luna trecută</div>
        </Card>
      </div>

      <Card title="Facturi Recente" subtitle="Ultimele facturi emise">
        <Table columns={columns} data={mockData.invoices} />
      </Card>
    </div>
  );
};

export default EmitereFacturi;